import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {TRACK_ACTION_PAYLOAD_KEY} from 'web-app/util/famlytics/action-tracking-constants';

const domain = 'ENTITIES/CONTACTS';

// CHILD CONTACTS

export const {action: addContacts} = createAction(`${domain}/ADD_CONTACTS`, contacts => ({contacts}));

export const {
    action: fetchChildContacts,
    success: fetchChildContactsSuccess,
    failed: fetchChildContactsFailed,
} = createAction(`${domain}/FETCH_CHILD_CONTACTS`, (childId, isLoginValidationEnabled) => ({
    childId,
    isLoginValidationEnabled,
}));

export const {
    action: fetchChildContact,
    success: fetchChildContactSuccess,
    failed: fetchChildContactFailed,
} = createAction(
    `${domain}/FETCH_CHILD_CONTACT`,
    relationId => relationId,
    relation => relation,
);

export const {action: updateContactsForChildren} = createAction(
    `${domain}/UPDATE_CONTACTS_FOR_CHILDREN`,
    relationMaps => ({relationMaps}),
);

export const {
    action: updateChildContact,
    success: updateChildContactSuccess,
    failed: updateChildContactFailed,
} = createAction(`${domain}/UPDATE_CHILD_CONTACTS`, (data, shouldUpdateSsn, shouldUpdateAddress, ssnToken) => ({
    data,
    shouldUpdateSsn,
    shouldUpdateAddress,
    ssnToken,
}));

export const {
    action: fetchKikuRelations,
    success: fetchKikuRelationsSuccess,
    failed: fetchKikuRelationsFailed,
} = createAction(
    `${domain}/FETCH_KIKU_RELATIONS`,
    childId => ({childId}),
    kikuRelations => ({kikuRelations}),
);

export const {
    action: updateKikuRelation,
    success: updateKikuRelationSuccess,
    failed: updateKikuRelationFailed,
} = createAction(
    `${domain}/UPDATE_KIKU_RELATION`,
    (relationId, kikuRelation) => ({relationId, kikuRelation}),
    (relationId, kikuRelation) => ({relationId, kikuRelation}),
);

export const {
    action: createChildContact,
    success: createChildContactSuccess,
    failed: createChildContactFailed,
} = createAction(
    `${domain}/CREATE_CHILD_CONTACT`,
    (relationId, roles) => ({
        relationId,
        roles,
        [TRACK_ACTION_PAYLOAD_KEY]: {
            case: 'new contact created',
            withLogin: roles.size !== 0,
            login: roles.size !== 0 ? roles.first()?.title : null,
        },
    }),
    (childId, contact) => ({
        childId,
        contact,
    }),
);

export const {
    action: deleteChildContact,
    success: deleteChildContactSuccess,
    failed: deleteChildContactFailed,
    aborted: deleteChildContactAborted,
} = createAction(
    `${domain}/DELETE_CHILD_CONTACT`,
    contact => ({contact}),
    successPayload => successPayload,
    (err, relationId) => ({message: err.message, stack: err.stack, relationId}),
);

export const {
    action: fetchChildContactSsn,
    success: fetchChildContactSsnSuccess,
    failed: fetchChildContactSsnFailed,
} = createAction(
    `${domain}/FETCH_CHILD_CONTACT_SSN`,
    (relationId, requiresPassword) => ({relationId, requiresPassword}),
    payload => payload,
    relationId => ({relationId}),
);

export const {
    action: fetchChildContactProtectedAddress,
    success: fetchChildContactProtectedAddressSuccess,
    failed: fetchChildContactProtectedAddressFailed,
} = createAction(`${domain}/FETCH_CHILD_CONTACT_PROTECTED_ADDRESS`, relationId => relationId);

export const {action: updateContactRoles} = createAction(`${domain}/UPDATE_CONTACT_ROLES`, (relationId, roles2) => ({
    relationId,
    roles2,
}));

// EMPLOYEE CONTACTS

export const {success: createEmployeeContactSuccess} = createAction(
    `${domain}/CREATE_EMPLOYEE_CONTACT`,
    data => ({data}),
    (employeeId, contact) => ({employeeId, contact}),
);

export const {
    action: fetchEmployeeContacts,
    success: fetchEmployeeContactsSuccess,
    failed: fetchEmployeeContactsFailed,
} = createAction(
    `${domain}/FETCH_EMPLOYEE_CONTACTS`,
    employeeId => ({employeeId}),
    (employeeId, contacts) => ({employeeId, contacts}),
);

export const {
    action: updateEmployeeContact,
    success: updateEmployeeContactSuccess,
    failed: updateEmployeeContactFailed,
} = createAction(`${domain}/UPDATE_EMPLOYEE_CONTACT`, data => ({data}));

export const {
    action: deleteEmployeeContact,
    success: deleteEmployeeContactSuccess,
    failed: deleteEmployeeContactFailed,
} = createAction(`${domain}/DELETE_EMPLOYEE_CONTACT`, contact => ({contact}));

export const {action: updateChildContactAfterRoleUpdate} = createAction(
    `${domain}/UPDATE_CHILD_CONTACT_AFTER_ROLE_UPDATE`,
    data => ({
        data,
        [TRACK_ACTION_PAYLOAD_KEY]: {
            case: 'role changed in child profile',
            withLogin: data.role.size !== 0,
            login: data.role.size !== 0 ? data.role.first()?.title : null,
        },
    }),
);

export const {action: fetchChildContactsWithRoleInvitations} = createAction(
    `${domain}/FETCH_CHILD_CONTACTS_WITH_ROLE_INVITATIONS`,
    (childId, relations) => ({
        childId,
        relations,
    }),
);
